export enum SelectionType {
  None = 'none',
  Include = 'include',
  Exclude = 'exclude'
}
